import { requestApi } from '@app/api';
import { withIdentityAccess } from '@app/api/paths';

export interface requesterMobileIdentifyResponse {
  timestamp: string;
  expiredAt: string;
  userName: string;
  phoneNumber: string;
}

/**
 * 요청자 본인인증
 */
export function requesterMobileIdentify({ impUid }: { impUid: string }) {
  return requestApi<requesterMobileIdentifyResponse>({
    url: withIdentityAccess('/users/mobile-identify'),
    method: 'POST',
    credentials: true,
    data: {
      impUid,
    },
  });
}
